export interface AuthStatus {
  setupComplete: boolean | null;
  unlocked: boolean;
  expiresAt?: number;
  offline?: boolean;
}

export async function fetchStatus(): Promise<AuthStatus> {
  let r: Response;
  try {
    r = await fetch("/api/auth/status");
  } catch {
    return { setupComplete: null, unlocked: false, offline: true };
  }
  if (!r.ok) {
    return { setupComplete: null, unlocked: false, offline: true };
  }
  const body = await r.json().catch(() => null);
  if (!body || typeof body.setupComplete !== "boolean") {
    return { setupComplete: null, unlocked: false, offline: true };
  }
  return body as AuthStatus;
}

export async function setupApi(passcode: string): Promise<void> {
  const r = await fetch("/api/auth/setup", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ passcode }),
  });
  if (!r.ok) throw new Error(`setup failed ${r.status}`);
}

export async function unlockApi(passcode: string): Promise<{ ok: boolean; remaining?: number; cooldownEndsAt?: number }> {
  let r: Response;
  try {
    r = await fetch("/api/auth/unlock", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ passcode }),
    });
  } catch {
    throw new Error("Network error — check your connection");
  }
  if (r.status === 401 || r.status === 429) {
    return r.json();
  }
  if (!r.ok) {
    throw new Error(`unlock failed ${r.status}`);
  }
  return r.json();
}

export async function lockApi(): Promise<void> {
  await fetch("/api/auth/lock", { method: "POST" });
}

export async function changePasscodeApi(current: string, next: string): Promise<{ ok: boolean }> {
  let r: Response;
  try {
    r = await fetch("/api/auth/passcode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ current, next }),
    });
  } catch {
    throw new Error("Network error — check your connection");
  }
  if (r.status === 204) return { ok: true };
  if (r.status === 401) return r.json();
  if (!r.ok) throw new Error(`passcode change failed ${r.status}`);
  return r.json();
}
